import { Pipe, PipeTransform, inject } from "@angular/core";

import {
    CTALink,
    CTAMissing,
    Tokens,
    TOKEN_TYPE,
} from "@hermes/api-model-editorial";
import { LOCALE } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

import { isCTALinkOrMissing } from "../helpers/editorial-cta.helper";

/**
 * This resolveTokens PIPE allow to parse the HTML contributed on BO and resolve
 * all "$TOKEN$" instance to a link element, the data-cta-spa directive is used to
 * add a click event via BindSPANavigationForCTADirective on the link to to do SPA navigation
 */
@Pipe({
    name: "resolveTokens",
    standalone: false,
})
export class ResolveTokensPipe implements PipeTransform {
    private locale = inject(LOCALE);

    public transform(
        value: string,
        tokens: Tokens = [],
        anchorCustomAttributesList: Array<string[] | undefined> = [],
        anchorClasses: string[] = [],
    ): string {
        const filteredTokens = tokens.filter(isCTALinkOrMissing);
        filteredTokens.forEach((token, index) => {
            value = value.replace(
                "$TOKEN$",
                resolveToken(
                    token,
                    anchorCustomAttributesList[index],
                    anchorClasses[index],
                    this.locale,
                ),
            );
        });
        return value;
    }
}

export const resolveToken = (
    token: Tokens[number],
    anchorCustomAttributes: string[] | undefined,
    anchorClass: string | undefined,
    locale: Locale,
) =>
    token.tokenType === TOKEN_TYPE.ctaMissing
        ? resolveCTAMissing(
              token as CTAMissing,
              anchorCustomAttributes,
              anchorClass,
              locale,
          )
        : resolveCTA(token as CTALink, anchorCustomAttributes, anchorClass);

export const resolveCTA = (
    cta: CTALink,
    anchorCustomAttributes: string[] | undefined,
    anchorClass: string | undefined,
) => {
    const allAttributes: string[] = [];

    if (anchorClass) {
        allAttributes.push(`class="${anchorClass}"`);
    }

    allAttributes.push("data-cta-spa", ...(anchorCustomAttributes ?? []), "");
    return `<a ${allAttributes.join(" ")}href="${cta.path}">${cta.text}</a>`;
};

export const resolveCTAMissing = (
    ctaMissing: CTAMissing,
    anchorCustomAttributes: string[] | undefined,
    anchorClass: string | undefined,
    locale: Locale,
) => {
    const allAttributes: string[] = [];

    if (anchorClass) {
        allAttributes.push(`class="${anchorClass}"`);
    }

    allAttributes.push(...(anchorCustomAttributes ?? []));
    if (allAttributes.length > 0) {
        allAttributes.push("");
    }
    return `<a ${allAttributes.join(" ")}href="${locale.urlPrefix}/">${
        ctaMissing.text
    }</a>`;
};
